export default {
    methods: {
        tastingDateFormatted(tastingDate, options = null, locale="de") {
            if (tastingDate === null) return "";
            if (options === null) options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(tastingDate).toLocaleDateString(locale, options);
        },
    },
}